/**
 * Natureza jurídica. Usada tanto pelo titular da conta (`Organization`/`Company`)
 * quanto por entidades que podem ser PF ou PJ (`Partner`, `User`).
 *
 * Mora em arquivo próprio porque `company.interface` e `user.interface` referenciam
 * as duas coisas — declarar o enum em qualquer um dos dois cria ciclo entre eles.
 */
export enum PersonType {
    FISICA = 'FISICA',
    JURIDICA = 'JURIDICA',
}
